export default "./images/survio-29BfS-assets-Watch.png";